import { defineAction, object } from '~/prix'
import ruralEnvironmentalRegistryProcess from './ruralEnvironmentalRegistryProcess.action.json' assert { type: 'json' }

const ruralEnvironmentalRegistryProcessDefinition = defineAction({
  ...ruralEnvironmentalRegistryProcess,
  input: object({}),
  output: object({}),
})

export default ruralEnvironmentalRegistryProcessDefinition
